<template>
  <el-dialog :title="currentUser?currentUser.toUserRealName : '聊天记录'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="800px" v-if="formVisible">
    <div class="date1">
      <img src="@/assets/date1.png" />
      <el-date-picker v-model="selectedDates" @change="changeDate" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
    </div>
    <div class="input-box">
      <el-input v-model="searchKeyword" placeholder="搜索" prefix-icon="el-icon-search"></el-input>
      <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
    </div>
    <div class="main-content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'" ref="msgBox" @scroll="scrollMainBox">
      <el-loading :visible="loading" />
      <div class="history-list">
        <div class="list-box">
          <div class="date" v-if="currentDate">{{currentDate}}</div>
          <div class="list" v-for="(item,index) in msgList" :key="index">
            <img class="head" :src="item.fromHeadImg" v-if="item.toUserId === currentUser.toUserId && item.toUserInfoId  === currentUser.toUserInfoId && item.toUserType  === currentUser.toUserType">
            <template v-else>
              <img class="head" :src="item.fromHeadImg" v-if="item.fromHeadImg">
              <img class="head" src="@/assets/du_logo.png" v-else>
            </template>
            <div class="user">
              <p>{{item.fromUserRealName}}<span>{{changeTime(item.createdTime)}}</span></p>
              <div class="content-box">
                <!-- // messageType 文本10 图像11 语音12 商品20 商品订单21 售后订单22 服务订单23  课程24 课程闯关25 -->
                <div class="content" v-if="item.messageType === 10">
                  <div class="text" v-html="replaceFace(item.messageContent)" />
                </div>
                <div v-if="item.messageType === 11" class="img-box">
                  <img :src="item.messageContent" style="max-width:100%">
                </div>
                <!-- 产品 -->
                <div class="prod-info" v-if="item.messageType === 20">
                  <div class="order-info">
                    <img :src="item.messageContent.img" />
                    <div class="order">
                      <p class="ellipsis1">{{item.messageContent.name}}</p>
                      <p>销量{{item.messageContent.virtualSalesCount}}</p>
                      <span>¥{{item.messageContent.retailPrice}}</span>
                    </div>
                  </div>
                </div>
                <!-- 订单 -->
                <div class="prod-info" v-if="item.messageType === 21 || item.messageType === 22">
                  <div class="order-info" v-if="item.messageContent.goods">
                    <img src="http://freesaasofficedata.oss.aliyuncs.com/2222/2b0f556c5f4740ada8e13b514aeea59071.jpg" />
                    <div class="order">
                      <p class="ellipsis1">{{item.messageContent.goods.afterGoodsName}}</p>
                      <p>共{{item.messageContent.goods.goodsCount}}件商品</p>
                    </div>
                  </div>
                  <div class="ord-no">
                    <div>订单号：{{item.messageContent.orderNum}}</div>
                    <div>创建时间：{{item.messageContent.createdTime || item.messageContent.applyTime}}</div>
                    <span>{{item.messageType === 21?(item.messageContent.type === 1?'订货订单':(item.messageContent.type === 2?'积分订单':'秒杀订单')):'售后订单'}}</span>
                  </div>
                </div>
                <!-- 课程 -->
                <div class="prod-info" v-if="item.messageType === 24">
                  <div class="order-info course">
                    <img :src="item.messageContent.coverImage" />
                    <div class="order">
                      <p class="ellipsis1">{{item.messageContent.name}}</p>
                      <p v-if="item.messageContent.lecturerRealName">主讲老师：{{item.messageContent.lecturerRealName}} <span class="level" v-if="item.messageContent.lecturerLevelName">【{{item.messageContent.lecturerLevelName}}】</span></p>
                      <em v-if="item.messageContent.chapterNum">共{{item.messageContent.chapterNum}}节</em>
                      <p class="eye"><i class="el-icon-view"></i>{{item.messageContent.playNum}}</p>
                    </div>
                  </div>
                </div>
                <!-- 闯关 -->
                <div class="challenge-box" v-if="item.messageType === 25">
                  <el-progress type="circle" :percentage="item.messageContent.completeRate" width="50" stroke-width="4"></el-progress>
                  <span>{{item.messageContent.name}}</span>
                  <em>{{item.messageContent.completeRate === 100?'已完成':(!item.messageContent.completeRate?'未开始':'闯关中')}}</em>
                </div>
                <!-- 预约服务 -->
                <div class="appointment" v-if="item.messageType === 23">
                  <div>你正在咨询线上预约服务订单</div>
                  <p>预约服务类型：{{item.messageContent.serviceItems}}</p>
                  <p>订单号：{{item.messageContent.orderNo}}</p>
                  <p>创建时间：{{item.messageContent.createdTime}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import imConversationMessageApi from '@/api/customer/imConversationMessage'
import { dateTime1, spaceTime } from "@/utils/dateTime.js";
import { formatDate, formatDateStr } from "@/utils/index"
export default {
  data() {
    return {
      currentDate: '', // 当前日期
      currentUser: null,
      form: null,
      msgList: [],
      formVisible: false,
      pageIndex: 1,
      pageSize: 10,
      dates: [],
      selectedDates: null,  //   选中的日期
      pickerOptions: {
        disabledDate: (date) => {
          return !this.dates.includes(date.getTime())
        }
      },
      isDownUp: 1,  //
      downPage: 0,
      upPage: 1,
      upFinished: false,
      downFinished: false,
      scrollToDown: 0,
      loading: false,
      searchKeyword: '',

    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 200;
    this.getByDate()
  },
  methods: {
    //获取有聊天记录的日期
    getByDate() {
      imConversationMessageApi.byDateGroup().then(res => {
        let serverDates = res.data.map(item => item.date)
        this.dates = serverDates.map(item => {
          return new Date(item).setHours(0)
        })
      })
    },
    // 重置分页相关状态的方法
    resetPageState() {

      this.msgList = [];           // 清空消息列表
      this.upFinished = false;     // 重置向上加载完成状态
      this.downFinished = false;   // 重置向下加载完成状态
      this.upPage = 1;            // 重置向上页码
      this.downPage = 0;          // 重置向下页码
      this.scrollToDown = 0;      // 重置滚动状态
      this.isDownUp = 1;          // 重置加载方向
      this.loading = false;       // 重置加载状态
    },
    //日期改变的时间
    changeDate() {
      if (!this.selectedDates) return;
      // 格式化选中的日期
      const date = formatDate(this.selectedDates) + ' 23:59:59';
      this.selectedDates = date;
      // 重置所有分页相关状态
      this.resetPageState();
      // 重新获取消息列表
      this.getMessageList();
    },
    changeTime(date) {
      return dateTime1(date);
    },
    scrollMainBox(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      //滚动在顶部
      if (scrollTop === 0) {
        this.isDownUp = 1
        this.getMessageList()
      }
      // 当滚动到底部100px以内时触发
      if (scrollHeight - (scrollTop + clientHeight) < 10) {
        this.isDownUp = 0
        // if(this.upPage === 1) return
        // else 
        this.getMessageList()
      }
    },
    handleShow(currentUser) {
      this.searchKeyword = ''
      this.resetPageState()
      this.currentUser = currentUser
      this.getMessageList()
    },
    replaceFace(con) {
      if (con.includes('/:')) {
        var emojis = this.emojis
        for (var i = 0; i < emojis.length; i++) {
          con = con.replace(
            emojis[i].reg,
            '<img src="static/emoji/' +
            emojis[i].file +
            '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />'
          )
        }
        return con
      }
      return con
    },
    // 添加搜索方法
    handleSearch() {
      this.resetPageState();
      this.getMessageList();
    },
    //获取消息列表
    getMessageList() {
      // 检查是否已经加载完成
      if ((this.isDownUp === 1 && this.upFinished) ||
        (this.isDownUp === 0 && this.downFinished)) {
        return;
      }
      if (this.loading) return
      this.loading = true;
      // 这里需要添加currentUser的空值检查
      if (!this.currentUser) {
        this.loading = false;
        return;
      }
      let { fromUserType, toUserId } = this.currentUser;
      if (this.isDownUp == 0) {
        this.upPage++;
      } else {
        this.downPage++;
      }
      let params = {
        operatorUserType: fromUserType,
        pageNo: this.isDownUp == 0 ? this.upPage : this.downPage,
        pageSize: this.pageSize,
        peerUserId: toUserId,
        currentCreatedTime: this.selectedDates || formatDateStr(new Date()),
        currentCreatedTimePrevNext: this.isDownUp == 0 ? 2 : 1,   //1 前  2后
        messageContent: this.searchKeyword
      }
      
      imConversationMessageApi.fetchList(params).then(({ data, code }) => {
        this.loading = false
        if (code === '0') {
          let list = data.list || [];
          list.forEach(item => {
            if (item.messageType > 11) {
              item.messageContent = JSON.parse(item.messageContent);
            }
            if (this.isDownUp == 1) {
              this.msgList.unshift(item);
            } else {
              this.msgList.push(item);
            }
          });
          if (list.length < this.pageSize) {
            if (this.isDownUp === 0) {
              this.upFinished = true;  // 向下加载完成
            } else {
              this.downFinished = true;  // 向上加载完成
            }
          }
          this.formVisible = true;
          if (!this.scrollToDown) {
            this.scrollToBottom()
          }
        }
      }).catch(error => {
        this.loading = false;
      });;
    },
    //滚动到底部
    scrollToBottom() {
      this.scrollToDown = 1;
      this.$nextTick(() => {
        const el = this.$refs.msgBox;
        if (!el) return;
        el.scrollTop = el.scrollHeight;
      })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  .el-button {
    margin: 0 10px;
  }
}
.date1 {
  position: absolute;
  right: 51px;
  top: 18px;
  cursor: pointer;
  img {
    width: 23px;
    height: 23px;
  }
  .el-date-editor {
    width: 23px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    z-index: 12;
  }
}
.history-list {
  margin-bottom: 15px;
  padding: 0 20px;
  .list-box {
    .date {
      font-size: 14px;
      padding-top: 18px;
    }
    .list {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      border-bottom: 1px solid rgba(197, 197, 197, 0.5);
      line-height: 22px;
      .head {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        object-fit: cover;
      }
      .user {
        width: calc(100% - 56px);
        display: inline-block;
        padding-left: 10px;
        p {
          font-size: 16px;
          margin: 0;
          color: #000;
          &:nth-child(1) {
            color: #6c6c6c;
            span {
              font-size: 14px;
              color: #000;
              float: right;
            }
          }
        }
      }
    }
  }
}
::v-deep .date1 .el-input--prefix .el-input__inner {
  padding-left: 0;
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
.content-box {
  max-width: 330px;
  display: inline-block;
  margin-top: 10px;
  .content {
    font-size: 14px;
    text-align: left;
  }
  .img-box {
    img {
      height: 100px;
    }
  }
  .prod-info {
    border: 1px solid #d9d9d9;
    padding: 12px;
    width: 300px;
    box-sizing: border-box;
    border-radius: 6px;
    .order-info {
      display: flex;

      img {
        width: 88px;
        height: 88px;
        object-fit: cover;
      }
      &.course {
        img {
          width: 98px;
          height: 124px;
          border-radius: 6px;
          object-fit: cover;
        }
      }
      .order {
        font-size: 14px;
        padding-left: 10px;
        width: calc(100% - 98px);
        position: relative;
        p {
          margin: 0;
          color: #6c6c6c;
          &:nth-child(2) {
            font-size: 13px;
            padding: 10px 0;
          }
        }
        span {
          color: #e73f3f;
          font-size: 13px;
          &.level {
            color: #f3b71d;
          }
        }
        em {
          font-size: 12px;
          color: #4680e3;
          padding: 6px;
          border-radius: 4px;
          background: #dae6f9;
          border: 1px solid #4680e3;
          font-style: normal;
        }
        .eye {
          font-size: 14px;
          color: #999;
          position: absolute;
          bottom: 5px;
          left: 10px;
          i {
            margin-right: 4px;
          }
        }
      }
    }
    .ord-no {
      padding-bottom: 10px;
      div {
        font-size: 14px;
        color: #6c6c6c;
        padding-top: 10px;
      }
      span {
        font-size: 13px;
        color: #1596cd;
        float: right;
      }
    }
  }
  .challenge-box {
    border: 1px solid #d9d9d9;
    padding: 12px;
    width: 300px;
    box-sizing: border-box;
    border-radius: 6px;
    display: flex;
    align-items: center;

    position: relative;
    span {
      font-size: 16px;
      color: #000f29;
      padding-left: 10px;
    }
    em {
      font-style: normal;
      font-size: 14px;
      color: #000f29;
      position: absolute;
      right: 12px;
    }
  }
  .appointment {
    border: 1px solid #d9d9d9;
    padding: 12px;
    width: 300px;
    box-sizing: border-box;
    border-radius: 6px;
    div {
      font-size: 16px;
      color: #000f29;
    }
    p {
      font-size: 14px;
      color: #666666;
      margin: 0;
      padding-top: 10px;
    }
  }
}
</style>
